module.exports = __webpack_public_path__ + "static/img/quit-coin.f3f10aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/quit-coin.png
// module id = F6y0
// module chunks = 215